import React, { useState } from 'react';
import { getAuth, signOut, EmailAuthProvider, reauthenticateWithCredential, trocarSenha } from './auth-compat';
import RequisitosSenha from './components/RequisitosSenha';
import { senhaForte } from './utils/senhaPolitica';

function ChangePassword() {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const auth = getAuth();
    const user = auth.currentUser;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!currentPassword) {
            setError('Por favor, informe sua senha atual.');
            return;
        }
        if (!senhaForte(newPassword)) {
            setError('A nova senha ainda não atende a todos os requisitos da lista.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('As senhas não coincidem.');
            return;
        }

        setLoading(true);

        try {
            if (user) {
                // 1. Re-autentica com a senha ATUAL antes de trocar
                // Isso resolve o erro "auth/requires-recent-login" do Firebase
                const credential = EmailAuthProvider.credential(user.email, currentPassword);
                await reauthenticateWithCredential(user, credential);

                // 2. Grava pelo servidor: regras, não pode ser parecida com a atual nem com
                //    as anteriores, e limpa o forcePasswordChange / "trocar agora"
                await trocarSenha(newPassword, currentPassword);

                alert('✅ Senha alterada com sucesso! Você será redirecionado ao sistema.');
                window.location.href = '/home';
            }
        } catch (err) {
            console.error(err);
            if (err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
                setError('❌ Senha atual incorreta. Verifique e tente novamente.');
            } else if (err.code === 'auth/requires-recent-login') {
                setError('Por segurança, faça login novamente antes de trocar a senha.');
                setTimeout(async () => {
                    await signOut(auth);
                    window.location.href = '/login';
                }, 3000);
            } else if (err.code === 'senha_parecida' || err.code === 'senha_fraca') {
                setError(err.message);
            } else {
                setError('Erro ao atualizar senha: ' + err.message);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-card">
                <h2 style={{ color: '#0f172a', fontWeight: 800, textAlign: 'center', marginBottom: '8px' }}>Troca de Senha Obrigatória</h2>
                <p style={{ marginBottom: '32px', textAlign: 'center', color: '#64748b', fontSize: '0.9rem' }}>Por segurança, você deve alterar sua senha no primeiro acesso.</p>

                <form onSubmit={handleSubmit}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                        <label style={{ fontWeight: 600, color: '#334155', display: 'block', marginBottom: '8px' }}>Senha Atual</label>
                        <input
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            required
                            placeholder="Digite a senha recebida"
                            style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}
                        />
                    </div>
                    <hr style={{ margin: '24px 0', border: 'none', borderTop: '1px solid #f1f5f9' }} />
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                        <label style={{ fontWeight: 600, color: '#334155', display: 'block', marginBottom: '8px' }}>Nova Senha</label>
                        <input
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            minLength={6}
                            style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}
                        />
                    </div>
                    <div className="form-group" style={{ marginBottom: '24px' }}>
                        <label style={{ fontWeight: 600, color: '#334155', display: 'block', marginBottom: '8px' }}>Confirmar Nova Senha</label>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            minLength={8}
                            style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}
                        />
                    </div>
                    <RequisitosSenha senha={newPassword} confirmacao={confirmPassword} />

                    {error && <p style={{ color: '#dc2626', fontSize: '0.85rem', fontWeight: 600, marginBottom: '20px', textAlign: 'center' }}>{error}</p>}

                    <button type="submit" className="btn-login" disabled={loading} style={{ width: '100%', padding: '14px', borderRadius: '12px', background: '#4f46e5', color: '#fff', border: 'none', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' }}>
                        {loading ? 'Atualizando...' : 'Definir Nova Senha'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default ChangePassword;
